<template>
  <div>
    经理提醒设置
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>